var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2F2E2E",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m24.895.354.707.707L1.561 25.102l-.707-.707z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.854 1.06 1.56.355l24.041 24.041-.707.707z"
  }))));
};
export default SvgClose;